import { render, staticRenderFns } from "./CoinList.vue?vue&type=template&id=11898f40&scoped=true"
import script from "./CoinList.vue?vue&type=script&lang=js"
export * from "./CoinList.vue?vue&type=script&lang=js"
import style0 from "./CoinList.vue?vue&type=style&index=0&id=11898f40&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11898f40",
  null
  
)

export default component.exports